import React, { useEffect, useRef, useState } from "react";
import BuySellBtn from "../CommonTocComponent/Stock/BuySellBtn";
import StockQuoteHeader from "../CommonTocComponent/Stock/StockQuoteHeader";
import TocStockHeader from "../CommonTocComponent/TocHeader/TocStockHeader";
import CustomValidityData from "./CustomValidity/CustomValidity";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import DiffMandate from "./Mandate/DiffMandate";
import { EInvestmentType, RedemptionBy, firstInstallmentConstentEnum, validityRadio, validityRadioEnum, } from "./MutualFundConstant";
import MutualFundTransaction from "./MutualFundTransaction";
import SelectScheme from "./SelectScheme/SelectScheme";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import PaymentMethod, { EPaymentType, } from "../NFO/paymentMethod/PaymentMethod";
import DiffrentBankAccount from "../NFO/paymentMethod/BankAccount/DiffrentBankAccount";
import CreateNewMandate from "./Mandate/CreateNewMandate";
import { EMFType } from "@domains/features/TOCJourney/entities/MFPurchase";
import RedeemData from "./RedeemComp/RedeemData";
import Redeembottom from "./RedeemComp/Redeembottom";
import LoaderEx from "./CommonComp/LoaderEx";
import { EPurchaseSchemePlan, } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import OrderConfirmation from "@frameworks/web/components/generic/TOCgeneric/OrderConfirmation";
import SingleHeadingText from "../CommonTocComponent/TocHeader/SingleHeadingText";
import { useSelector } from "react-redux";
import _ from "underscore";
import { useParams } from "react-router-dom";
import moment from "moment";
import PaymentUpi from "./CommonComp/PaymentUpi";
import PaymentStatus from "./CommonComp/PaymentStatus";
import FailPayment from "@frameworks/web/assets/images/features/TOC/Common/FailPayment.svg";
import PaymentSucessFail from "../NFO/PaymentScreen/PaymentSucessFail";
export var EMutualFundFlow;
(function (EMutualFundFlow) {
    EMutualFundFlow["PURCHASE"] = "purchase";
    EMutualFundFlow["SCHEME"] = "scheme";
    EMutualFundFlow["MANDATE"] = "mandate";
    EMutualFundFlow["NEWMANDATE"] = "newMandate";
    EMutualFundFlow["VALIDITY"] = "validity";
    EMutualFundFlow["CONFIRMATION"] = "confirmation";
    EMutualFundFlow["PAYMENT"] = "payment";
    EMutualFundFlow["BANKACCOUNT"] = "bankAccount";
    EMutualFundFlow["REDEEM"] = "redeem";
    EMutualFundFlow["LOADER"] = "loader";
    EMutualFundFlow["PAYEMENTFAILURE"] = "paymentFailure";
    EMutualFundFlow["PAYEMENTSUCCESS"] = "paymentSuccess";
    EMutualFundFlow["FAIL"] = "fail";
    EMutualFundFlow["IBPAGE"] = "IBPage";
    EMutualFundFlow["UPIAPPROVAL"] = "upiApproval";
})(EMutualFundFlow || (EMutualFundFlow = {}));
const MutualFund = (props) => {
    const MFTransactionRef = useRef(null);
    const device = DeviceContext();
    const { isin: isinParam, ifNfo } = useParams();
    const [purchaseFormData, setPurchaseFormData] = useState();
    const [tocFlow, setTOCFlow] = useState(EMutualFundFlow.PURCHASE);
    const [previousScreenState, setPreviousScreenState] = useState(EMutualFundFlow.PURCHASE);
    const [tocType, setTocType] = useState(EMFType.PURCHASE);
    const [orderConfirmationList, setOrderConfirmationList] = useState();
    const [sipFrequency, setSipFrequency] = useState();
    const [mfData, setMFData] = useState();
    const [catDetails, setCatDetails] = useState({
        category: "",
        subCategory: "",
    });
    const [startDate, setStartDate] = useState();
    const [selectedMandate, setSelectedMandate] = useState();
    const [mandateList, setMandateList] = useState();
    const [bankList, setBankList] = useState();
    const [selectedBank, setSelectedBank] = useState();
    const [investmentType, setInvestmentType] = useState(EInvestmentType.SIP);
    const [folio, setFolio] = useState();
    const [reqPayload, setReqPayload] = useState({});
    const [isin, setISIN] = useState(props.isin || isinParam); //INF209K01RU9
    const [orderData, setOrderData] = useState();
    const [selectedScheme, setSelectedScheme] = useState({
        schemeType: "",
        returnType: "",
        divFrequency: "",
    });
    const [selectedUpi, setSelectedUpi] = useState({
        upi: "",
        bankAcnt: "",
        bankCd: "",
        ifsc: "",
    });
    const [redeemMode, setRedeemMode] = useState("Partial");
    const [redeemBy, setRedeemBy] = useState("Units");
    const [redeemByOption, setRedeemByOption] = useState(RedemptionBy);
    const [html, setHTML] = useState({ __html: "" });
    const [paymentMethod, setPaymentMethod] = useState();
    const [scriptDetails, setScriptDetails] = useState();
    const [paymentstatusDetails, setPaymentstatusDetails] = useState();
    const paymentRef = useRef(null);
    const [curDate, setCurDate] = useState("");
    const mfHoldingData = useSelector((state) => state.TOCJourney.mfParticularHolding, _.isEqual);
    const hendleScreenState = (ss) => {
        setPreviousScreenState(tocFlow);
        setTOCFlow(ss);
    };
    const getMFPurchaseData = () => {
        (ifNfo
            ? tocDi.tocJourney.getNfoPurchase({
                isin: isin,
                action: tocType,
            })
            : tocDi.tocJourney.getMFPurchase({
                isin: isin,
                action: tocType,
            }))
            .then((data) => {
            var _a, _b, _c, _d, _e;
            setMFData(tocType === EMFType.PURCHASE
                ? data.data.purchaseDetails
                : data.data.redeemDetails);
            if (tocType === EMFType.PURCHASE &&
                ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.purchaseDetails) &&
                data.data.purchaseDetails.sipflag != "Y") {
                setInvestmentType(EInvestmentType.LUMPSUM);
            }
            if (tocType === EMFType.PURCHASE &&
                ((_c = (_b = data.data) === null || _b === void 0 ? void 0 : _b.purchaseDetails) === null || _c === void 0 ? void 0 : _c.sipflag) == "Y" &&
                investmentType === EInvestmentType.SIP)
                getMFSIPFrequency(data.data.purchaseDetails);
            if (tocType === EMFType.PURCHASE)
                setCatDetails({
                    category: (_d = data.data) === null || _d === void 0 ? void 0 : _d.purchaseDetails.category,
                    subCategory: (_e = data.data) === null || _e === void 0 ? void 0 : _e.purchaseDetails.subCategory,
                });
            hendleScreenState(tocType);
        })
            .catch((error) => {
            console.log(error);
        });
    };
    const getOrderStatus = (time) => {
        if (time % 5 === 0) {
            tocDi.payment
                .getMfPaymentStatus({
                ordNo: orderData.ordNo,
                txnDt: moment().format("YYYY-MM-DD"),
                exOrdNo: "",
                pay: "true",
            })
                .then((data) => {
                if (data === null || data === void 0 ? void 0 : data.status) {
                    if ((time < 1 && data.status == "CONTINUE") ||
                        (data.status != "ERROR" && data.status != "CONTINUE")) {
                        setPaymentstatusDetails((list) => {
                            const statusList = [
                                { title: "Date and Time", value: curDate },
                                {
                                    title: "Amount",
                                    value: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount.toString(),
                                },
                                { title: "Account No", value: selectedBank.bnkAcNo },
                                { title: "Bank Name", value: selectedBank.bnkNm },
                            ];
                            if (paymentMethod === EPaymentType.UPI) {
                                statusList.push({ title: "UPI ID", value: selectedUpi.upi });
                            }
                            statusList.push({ title: "Scheme", value: mfData === null || mfData === void 0 ? void 0 : mfData.schemename }, { title: "Type", value: investmentType }, { title: "Return Option", value: mfData === null || mfData === void 0 ? void 0 : mfData.schemetype });
                            if (investmentType === EInvestmentType.SIP) {
                                statusList.push({
                                    title: "SIP Type",
                                    value: purchaseFormData.sipValidationPreset ===
                                        validityRadioEnum.UNTIL_CANCELLED
                                        ? "Perpetual"
                                        : "Normal",
                                }, {
                                    title: "Frequency",
                                    value: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency,
                                }, {
                                    title: "Duration",
                                    value: purchaseFormData.sipValidationPreset ===
                                        validityRadioEnum.CUSTOME
                                        ? purchaseFormData.sipValidationCustom
                                        : purchaseFormData.sipValidationPreset,
                                }, { title: "SIP Date", value: purchaseFormData.sipDate }, { title: "Mandate ID", value: selectedMandate.mandateId });
                            }
                            statusList.push({ title: "Order ID", value: orderData.ordNo });
                            return statusList;
                        });
                        if (data.status == "SUCCESS")
                            hendleScreenState(EMutualFundFlow.PAYEMENTSUCCESS);
                        else
                            hendleScreenState(EMutualFundFlow.PAYEMENTFAILURE);
                    }
                }
            })
                .catch((error) => {
                console.log(error);
            });
        }
    };
    const getMFSIPFrequency = (mfDa) => {
        tocDi.tocJourney
            .getSipFrequency({
            isin: isin,
            amcCd: mfDa === null || mfDa === void 0 ? void 0 : mfDa.amccode,
            scmCd: mfDa === null || mfDa === void 0 ? void 0 : mfDa.schemeCode,
        })
            .then((data) => {
            setSipFrequency(data.sipLst);
            setPurchaseFormData((fData) => {
                return Object.assign(Object.assign({}, fData), { sipFrequency: data.sipLst[0].freq });
            });
            getSipStartDateData(data.sipLst[0].freq, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mfDa);
        })
            .catch((err) => console.log(err));
    };
    const getSipStartDateData = (frq = purchaseFormData.sipFrequency, fi = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mfDa = mfData) => {
        tocDi.tocJourney
            .getSipStartDate({
            amcCd: mfDa === null || mfDa === void 0 ? void 0 : mfDa.amccode,
            scmCd: mfDa === null || mfDa === void 0 ? void 0 : mfDa.schemeCode,
            isin: mfDa === null || mfDa === void 0 ? void 0 : mfDa.isin,
            frq: frq,
            txnTyp: "XSIP",
            gfot: fi,
            mandateId: (selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId) || "",
        })
            .then((data) => {
            if (data.dtLst.length > 0) {
                setStartDate(data.dtLst);
                setPurchaseFormData((fData) => {
                    return Object.assign(Object.assign({}, fData), { sipDate: data.dtLst[0] });
                });
            }
        })
            .catch((err) => console.log(err));
    };
    const getMfMandate = () => {
        tocDi.mandate
            .getMfMandate()
            .then((data) => {
            if (data.lst.length > 0) {
                setMandateList(data.lst);
                setSelectedMandate(data.lst[0]);
            }
        })
            .catch((error) => console.log(error));
    };
    const getMfBankDetails = () => {
        tocDi.mandate
            .getMfBankDetails()
            .then((data) => {
            if (data.lst.length > 0) {
                setBankList(data.lst);
                setSelectedBank(data.lst.find((x) => x.def));
            }
        })
            .catch((error) => console.log(error));
    };
    const onSubmit = () => {
        hendleScreenState(EMutualFundFlow.LOADER);
        const investFlag = (mfData === null || mfData === void 0 ? void 0 : mfData.schemetype) === "Dividend - Reinvest"
            ? "Y"
            : (mfData === null || mfData === void 0 ? void 0 : mfData.schemetype) === "Growth"
                ? "Z"
                : (mfData === null || mfData === void 0 ? void 0 : mfData.schemetype) === "Dividend - Payout"
                    ? "N"
                    : "";
        const payload = {
            //currentOrdSts: EPurchaseOrderStatus.ACCEPTED,
            token: mfData === null || mfData === void 0 ? void 0 : mfData.token,
            isin: isin,
            txnTyp: mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.data.purchaseType,
            qty: 0,
            amt: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount,
            reInvFlg: investFlag,
            ordTyp: "FRESH",
            txnId: 0,
            schemeName: mfData === null || mfData === void 0 ? void 0 : mfData.schemename,
            ordSrc: "WEB",
            schemePlan: EPurchaseSchemePlan.REGULAR,
            schemeCode: mfData === null || mfData === void 0 ? void 0 : mfData.schemeCode,
            gfot: purchaseFormData.firstInstallment,
        };
        if (investmentType === EInvestmentType.SIP) {
            payload.sipFrq = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency;
            payload.strtDt = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate;
            payload.strtDy = Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate.split(" ")[0]);
            payload.tnr =
                (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom) === ""
                    ? purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset
                    : purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom;
            payload.txnTyp = "XSIP";
            payload.gfot = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment;
            payload.mdtId = selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId;
        }
        if (tocType === EMFType.REDEEM) {
            payload.txnTyp = "R";
            if ((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity) > 0) {
                payload.qty = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity;
            }
            else {
                payload.amt = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.redeemAmount;
            }
        }
        tocDi.tocJourney
            .mfPurchaseOrder(payload)
            .then((data) => {
            setOrderData(data);
            if (purchaseFormData.firstInstallment === firstInstallmentConstentEnum.NOW) {
                hendleScreenState(EMutualFundFlow.PAYMENT);
            }
        })
            .catch((error) => {
            console.log(error);
            hendleScreenState(EMutualFundFlow.CONFIRMATION);
        });
    };
    const onPaymentSubmit = () => {
        var _a, _b, _c, _d, _e;
        const bank = (_a = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _a === void 0 ? void 0 : _a.getSelectedBank();
        const upi = (_b = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _b === void 0 ? void 0 : _b.getSelectedUPI();
        const method = (_c = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _c === void 0 ? void 0 : _c.getPaymentMethod();
        const allBanks = (_d = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _d === void 0 ? void 0 : _d.getBankDetails();
        setPaymentMethod(method);
        let payload = {
            exOrdNo: "",
            orderNo: orderData.ordNo,
            amount: purchaseFormData.amount.toString(),
        };
        if (method === EPaymentType.NetBanking) {
            payload = Object.assign(Object.assign({}, payload), { bankAccount: bank === null || bank === void 0 ? void 0 : bank.bnkAcNo, ifsc: bank === null || bank === void 0 ? void 0 : bank.ifscCode, bankCd: bank === null || bank === void 0 ? void 0 : bank.bankId.toString(), mode: (bank === null || bank === void 0 ? void 0 : bank.brn) ? bank === null || bank === void 0 ? void 0 : bank.brn : "" });
        }
        if (method === EPaymentType.UPI) {
            const upiBankDtls = (_e = allBanks.bnkAcs) === null || _e === void 0 ? void 0 : _e.find(function (bank) {
                return bank.bnkAccNo == upi.bankaccountnumber;
            });
            payload = Object.assign(Object.assign({}, payload), { upi: upi === null || upi === void 0 ? void 0 : upi.upid, bankAccount: upi === null || upi === void 0 ? void 0 : upi.bankaccountnumber, bankCd: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bnkCode, ifsc: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.ifsc });
            setSelectedUpi({
                upi: upi === null || upi === void 0 ? void 0 : upi.upid,
                bankAcnt: upi === null || upi === void 0 ? void 0 : upi.bankaccountnumber,
                bankCd: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bnkCode,
                ifsc: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.ifsc,
            });
        }
        if (investmentType === EInvestmentType.SIP) {
            payload.mandateId = selectedMandate.mandateId;
        }
        setCurDate(moment().format("DD-MMM-YY, h:mm:ss"));
        tocDi.payment
            .tradePayment(payload)
            .then((data) => {
            if (method === EPaymentType.NetBanking) {
                if ((data === null || data === void 0 ? void 0 : data.responsestring) && (data === null || data === void 0 ? void 0 : data.exOrdNo)) {
                    const backendHtmlString = data.responsestring.toString();
                    let extractedScript = /<script>[\s\S]*<\/script>/g.exec(backendHtmlString);
                    setHTML({ __html: backendHtmlString });
                    setScriptDetails(extractedScript[0]);
                }
            }
            else if (method === EPaymentType.UPI) {
                if ((data === null || data === void 0 ? void 0 : data.responsestring) && (data === null || data === void 0 ? void 0 : data.exOrdNo)) {
                    hendleScreenState(EMutualFundFlow.UPIAPPROVAL);
                }
            }
        })
            .catch((err) => {
            console.log(err);
        });
    };
    function MyComponent() {
        return (React.createElement("div", { className: "payment-waiting-page", dangerouslySetInnerHTML: html }));
    }
    const orderConfrimation = () => {
        hendleScreenState(EMutualFundFlow.LOADER);
        setOrderConfirmationList((data) => {
            const base = [
                { title: "Category", value: catDetails.category },
                { title: "Sub category", value: catDetails.subCategory },
                { title: "Investment Type", value: investmentType },
                { title: "Return Option", value: mfData === null || mfData === void 0 ? void 0 : mfData.schemetype },
                { title: "DIV Frequency", value: mfData === null || mfData === void 0 ? void 0 : mfData.divFrq },
                { title: "Amount", value: `${purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount}` },
            ];
            if (investmentType === EInvestmentType.SIP) {
                base.push({
                    title: "SIP Frequency",
                    value: `${purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency}`,
                }, {
                    title: "SIP Day",
                    value: `${purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate.split(" ")[0]}`,
                }, {
                    title: "Validity",
                    value: (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset) ===
                        validityRadioEnum.CUSTOME
                        ? purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom
                        : purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset,
                }, {
                    title: "Next SIP to be Deducted",
                    value: `${purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate}`,
                });
            }
            return base;
        });
        setTimeout(() => {
            hendleScreenState(EMutualFundFlow.CONFIRMATION);
        }, 500);
    };
    const purchaseApplyBtnDisabled = () => {
        if (!(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) ||
            (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) <
                (!!(mfData === null || mfData === void 0 ? void 0 : mfData.minpuramt) && Number(mfData === null || mfData === void 0 ? void 0 : mfData.minpuramt))) {
            return true;
        }
        else if (investmentType === EInvestmentType.SIP &&
            (!(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment) ||
                !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency) ||
                !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset) ||
                ((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset) === validityRadioEnum.CUSTOME &&
                    !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom)))) {
            return true;
        }
        else {
            return false;
        }
    };
    useEffect(() => {
        if (html && html.__html != "")
            hendleScreenState(EMutualFundFlow.IBPAGE);
    }, [html]);
    useEffect(() => {
        let scriptToRun = scriptDetails;
        if (scriptToRun !== undefined && html && html.__html != "") {
            // remove <script> and </script> tags since eval expects only code without html tags
            let scriptLines = scriptToRun.split("\n");
            scriptLines.pop();
            scriptLines.shift();
            let cleanScript = scriptLines.join("\n");
            window.eval(cleanScript);
        }
    }, [scriptDetails, html]);
    useEffect(() => {
        hendleScreenState(EMutualFundFlow.LOADER);
        getMFPurchaseData();
        tocDi.tocJourney.mfParticularHolding({
            isin: isin,
        });
    }, [tocType, isin]);
    useEffect(() => {
        getMfMandate();
        getMfBankDetails();
        setPurchaseFormData({
            amount: 0,
            firstInstallment: firstInstallmentConstentEnum.NOW,
            sipFrequency: "",
            sipDate: "",
            sipValidationPreset: validityRadio[0].value,
            sipValidationCustom: "",
        });
    }, []);
    useEffect(() => {
        var _a;
        if ((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom) ||
            (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset)) {
            (_a = MFTransactionRef === null || MFTransactionRef === void 0 ? void 0 : MFTransactionRef.current) === null || _a === void 0 ? void 0 : _a.updateFormData(Object.assign({}, purchaseFormData));
        }
    }, [
        purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationPreset,
        purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipValidationCustom,
    ]);
    const TOCFlow = () => {
        switch (tocFlow) {
            case EMutualFundFlow.LOADER:
                return React.createElement(LoaderEx, { showMsg: false });
            case EMutualFundFlow.PURCHASE:
                return (React.createElement(React.Fragment, null,
                    React.createElement(TocStockHeader, { children: React.createElement(StockQuoteHeader, { stockTitle: mfData === null || mfData === void 0 ? void 0 : mfData.schemename, payout: mfData === null || mfData === void 0 ? void 0 : mfData.schemetype, setChanges: hendleScreenState, show: true, hideAdditionalDetails: false, parentClassName: "mutual-fund-head", navDate: mfData === null || mfData === void 0 ? void 0 : mfData.timestamp, ltp: mfData === null || mfData === void 0 ? void 0 : mfData.nav }) }),
                    React.createElement(MutualFundTransaction, { sipFrequency: sipFrequency, startDate: startDate, setTOCFlow: hendleScreenState, selectedMandate: selectedMandate, investmentType: investmentType, setInvestmentType: setInvestmentType, ref: MFTransactionRef, mfData: mfData, orderConfrimation: orderConfrimation, hendleScreenState: hendleScreenState, setStartDate: setStartDate, getSipStartDateData: getSipStartDateData, purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData }),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Redeem", refreshLabelClassName: "grid-container-full", buySellRefresh: (mfData === null || mfData === void 0 ? void 0 : mfData.redallowed) ? true : false, rightButton: {
                                btnTyp: "midnight-blue",
                                value: investmentType === EInvestmentType.LUMPSUM
                                    ? "Invest"
                                    : "Pay and start SIP",
                                className: "w-100",
                                onClick: () => {
                                    orderConfrimation();
                                    // hendleScreenState(EMutualFundFlow.PAYMENT);
                                },
                                disabled: purchaseApplyBtnDisabled(),
                            }, onCallBackFunction: () => {
                                setTocType(EMFType.REDEEM);
                                hendleScreenState(EMutualFundFlow.REDEEM);
                            } }))));
            case EMutualFundFlow.REDEEM:
                return (React.createElement(React.Fragment, null,
                    React.createElement(TocStockHeader, { children: React.createElement(StockQuoteHeader, { stockTitle: mfData === null || mfData === void 0 ? void 0 : mfData.schemename, payout: mfData === null || mfData === void 0 ? void 0 : mfData.schemetype, setChanges: hendleScreenState, show: true, hideAdditionalDetails: false, parentClassName: "mutual-fund-head", navDate: mfData === null || mfData === void 0 ? void 0 : mfData.timestamp, ltp: mfData === null || mfData === void 0 ? void 0 : mfData.nav }) }),
                    React.createElement(RedeemData, { isin: isin, setFolio: setFolio, folio: folio, ltp: mfData === null || mfData === void 0 ? void 0 : mfData.nav, purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData, redeemBy: redeemBy, redeemMode: redeemMode, redeemByOption: redeemByOption, setRedeemBy: setRedeemBy, setRedeemMode: setRedeemMode, setRedeemByOption: setRedeemByOption }),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(Redeembottom, null),
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Invest", refreshLabelClassName: "grid-container-full", buySellRefresh: true, rightButton: {
                                btnTyp: "midnight-blue",
                                value: "Redeem",
                                className: "w-100",
                                disabled: !((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity) > 0 ||
                                    (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.redeemAmount) > 0),
                                onClick: () => hendleScreenState(EMutualFundFlow.CONFIRMATION),
                            }, onCallBackFunction: () => {
                                setTocType(EMFType.PURCHASE);
                                hendleScreenState(EMutualFundFlow.PURCHASE);
                            } }))));
            case EMutualFundFlow.SCHEME:
                return (React.createElement(SelectScheme, { show: true, setShow: () => hendleScreenState(EMutualFundFlow.PURCHASE), mfData: mfData, setISIN: setISIN, setCatDetails: setCatDetails, setSelectedScheme: setSelectedScheme }));
            case EMutualFundFlow.BANKACCOUNT:
                return (React.createElement(DiffrentBankAccount, { back: () => hendleScreenState(previousScreenState), next: () => hendleScreenState(previousScreenState), bankList: bankList, setSelectedBank: setSelectedBank, selectedBank: selectedBank }));
            case EMutualFundFlow.PAYMENT:
                return (React.createElement(PaymentMethod, { back: () => hendleScreenState(previousScreenState), next: () => hendleScreenState(EMutualFundFlow.PURCHASE), ref: paymentRef, onSubmit: onPaymentSubmit }));
            case EMutualFundFlow.CONFIRMATION:
                return ((orderConfirmationList === null || orderConfirmationList === void 0 ? void 0 : orderConfirmationList.length) > 0 && (React.createElement(React.Fragment, null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Order Confirmation" }) })),
                    React.createElement(OrderConfirmation, { stockName: mfData === null || mfData === void 0 ? void 0 : mfData.schemename, description: "", change: mfData === null || mfData === void 0 ? void 0 : mfData.changeinnav, changePer: mfData === null || mfData === void 0 ? void 0 : mfData.changeinnavper, ltp: mfData === null || mfData === void 0 ? void 0 : mfData.nav, orderBodyList: orderConfirmationList, exchange: "", quantity: "", validity: "", activeButton: undefined, disclosedQty: "", hideAdditionalDetails: true, showPaymentNotification: false, showMandate: false }),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(BuySellBtn, { rightButton: {
                                btnTyp: "midnight-blue",
                                value: "confirm",
                                className: "w-100",
                                onClick: () => {
                                    onSubmit();
                                    //  hendleScreenState(EMutualFundFlow.PAYMENT);
                                },
                            }, cancelAction: () => hendleScreenState(EMutualFundFlow.PURCHASE), onCallBackFunction: () => {
                                setTocType(tocType);
                                hendleScreenState(EMutualFundFlow.PURCHASE);
                            }, refreshLabelTitle: "" })))));
            case EMutualFundFlow.MANDATE:
                return (React.createElement(DiffMandate, { show: false, setShow: hendleScreenState, mandateList: mandateList, selectedMandate: selectedMandate, setSelectedMandate: setSelectedMandate }));
            case EMutualFundFlow.NEWMANDATE:
                return (React.createElement(CreateNewMandate, { show: true, setShow: hendleScreenState, selectedBank: selectedBank, setSelectedMandate: setSelectedMandate, selectedMandate: selectedMandate }));
            case EMutualFundFlow.VALIDITY:
                return (React.createElement(React.Fragment, null,
                    React.createElement(CustomValidityData, { show: true, setShow: () => hendleScreenState(EMutualFundFlow.PURCHASE), purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData })));
            case EMutualFundFlow.IBPAGE:
                return React.createElement(MyComponent, null);
            case EMutualFundFlow.UPIAPPROVAL:
                return (React.createElement(PaymentUpi, { duration: 26, checkStatus: getOrderStatus, amount: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount }));
            case EMutualFundFlow.PAYEMENTFAILURE:
                return (React.createElement(PaymentStatus, { paymentstatusDetails: paymentstatusDetails, titleHead: true ? "Payment Successfull" : "Payment Failed", selectedMandate: selectedMandate }));
            case EMutualFundFlow.PAYEMENTSUCCESS:
                return (React.createElement(PaymentSucessFail, { title: "Payment Failed", Message: "Your payment for SIP investment has failed. You can retry the payment from Orderbook", image: FailPayment }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TOCFlow, null)));
};
export default MutualFund;
{
    /* /********* payment successful******** */
}
{
    /* <div className="mgt-20">
            <div>
              <PaymentSucessFail
                title={"Payment Successful"}
                Message={PaymentSucessMsg}
                image={succesPayment}
              />
            </div>
            <div className="bank-account-sucess">
              <BankAccount
                sectionHeadleftTop={"Bank Account Number"}
                sectionHeadleftBottom={"37862393984"}
                sectionHeadRightTop={"Bank Name"}
                sectionHeadRightBottom={"HDFC Bank"}
                parentClass="payment-account mb-3"
                hideIcon={true}
              />
              <BankAccount
                sectionHeadleftTop={"Bank Name"}
                sectionHeadleftBottom={"ICICI Bank"}
                sectionHeadRightTop={"Amount"}
                sectionHeadRightBottom={"₹5,000"}
                parentClass="payment-account"
                hideIcon={true}
              />
            </div>
          </div> */
    {
        /* /********* payment Fail******** */
    }
    {
        /* <div className="mgt-20">
              <PaymentSucessFail
                title={"Payment Failed"}
                Message={PaymentFailMsg}
                image={FailPayment}
              />
            </div> */
    }
}
// new design error state (screen -108)
{
    /* <ErrorState msg={"Insufficient amount for redemption"} />; */
    // screen no 288
    // <PaymentOrderScreen />;
}
